import React from 'react';
import withIcon from '../utilities/withIcon';

const IconDocumentUser = () => {
  return (
    <g>
      <path d="m8 10.7448c1.4893 0 2.271-2.3412 1.6728-3.6546a1.7923 1.7923 0 0 0 -1.6728-1.0416 1.7924 1.7924 0 0 0 -1.6728 1.0414c-.598 1.3136.1836 3.6548 1.6728 3.6548z" />
      <path d="m14.4845.042h-9.4482a.7608.7608 0 0 0 -.53.22l-3.5247 3.5241a.7433.7433 0 0 0 -.2158.55v10.8719a.75.75 0 0 0 .75.75h12.9687a.75.75 0 0 0 .75-.75v-14.416a.75.75 0 0 0 -.75-.75zm-9.668 2.03v2.0208h-2.0205zm8.918 12.3857h-1.6045c-.0039-2.8742-1.004-2.07-2.5243-3.0574a.407.407 0 0 0 -.5287.0661l-.8569.8625a.31.31 0 0 1 -.44 0l-.8569-.8625a.4072.4072 0 0 0 -.5287-.0661c-1.52.9879-2.52.1833-2.524 3.0574h-1.6047v-8.8649h3.3008a.75.75 0 0 0 .75-.75v-3.3008h7.418z" />
    </g>
  );
};

export default withIcon(IconDocumentUser);
